import React from 'react';
import './ShareModal.scss';
import PropTypes from 'prop-types';

const preventDefaultHandler = (event) => {
  event.preventDefault(); // 阻止默认事件
  event.stopPropagation(); // 阻止冒泡
  event.nativeEvent.stopImmediatePropagation(); // 阻止冒泡
};

const ShareModal = ({ text, onSubmit = () => {}, onCancle = () => {} }) => {
  const cancleHandler = (event) => {
    onCancle();
    preventDefaultHandler(event);
  };
  const submintHandler = (event) => {
    onSubmit();
    preventDefaultHandler(event);
  };
  return (
    <div className="sharelp-modal" onClick={cancleHandler}>
      <div className="box">
        <div className="sharelp-modal--content">{text}</div>
        <div className="sharelp-modal--footer">
          <div className="sharelp-modal-btn cancle" onClick={cancleHandler}>
            取消
          </div>
          <div className="sharelp-modal-btn ok" onClick={submintHandler}>
            用QQ浏览器打开
          </div>
        </div>
      </div>
    </div>
  );
};

ShareModal.propTypes = {
  onSubmit: PropTypes.func,
  onCancle: PropTypes.func,
  text: PropTypes.string,
};

ShareModal.defaultProps = {
  text: '“天天快报极速版”iPhone版本暂未上线，是否用浏览体验同样畅爽的QQ浏览器打开。',
};

export default ShareModal;
